import { useSelector } from "react-redux";
import { selectProgramId } from "../../Store/api/program/programSelectors";
import { useGetProgramSettingBySettingNameQuery } from "../../Store/api/apiSlice";
import { SettingNames } from "../../MPP-Common-SPA/programSettings/enums";

export const useSupportingInfo = () => {
  const programId = useSelector(selectProgramId);

  const { data: setting } = useGetProgramSettingBySettingNameQuery(
    {
      settingName: SettingNames.PublicNotificationsSupportInformation,
      programId,
    },
    { skip: !programId },
  );

  try {
    const config = JSON.parse(setting?.configuration || "{}");
    return config?.Content || "";
  } catch {
    return "";
  }
};
